export const DayOfWeekPresets = {
  EVERY_DAY: 'EVERY_DAY',
  WEEKDAY: 'WEEKDAY',
  WEEKEND: 'WEEKEND'
};
export const DaysOfWeekByPresets = {
  [DayOfWeekPresets.EVERY_DAY]: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'],
  [DayOfWeekPresets.WEEKDAY]: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'],
  [DayOfWeekPresets.WEEKEND]: ['SATURDAY', 'SUNDAY']
};